import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import ALKA from '../../ui/svg/alka';
import COMEON from '../../ui/svg/comeon';
import COMEON18 from '../../ui/svg/comeon18';
import COMEONBLACK from '../../ui/svg/comeon_black';
import COMEONBOX from '../../ui/svg/comeon_box';
import BTDK from '../../ui/svg/btdk';
import TemplateConstants from '../templates/TemplateConstants.js';

const getCss = props => {
    const { placement, position } = props;
    const styles = {
        bottom: 'top: auto; bottom: 0;',
        top: 'top: 0; bottom: auto;',
        rtl: 'flex-direction: row-reverse;',
        ltr: 'flex-direction: row;',
        absolute: 'position: absolute;',
        relative: `position: relative;`,
        left: 'justify-content: flex-start;',
        right: 'justify-content: flex-end;',
        center: 'justify-content: center;',
        edges: 'justify-content: space-between;',
    };

    if (placement === 'relative') {
        styles.top += `margin-top: -${props.theme.contentPadding}px;margin-bottom: ${props.theme.contentPadding}px;`;
        styles.bottom += `margin-bottom: -${props.theme.contentPadding}px;margin-top: ${props.theme.contentPadding}px;`;
        styles.relative += `margin-left: -${props.theme.contentPadding + 15}px;margin-right: -${props.theme
            .contentPadding + 15}px;`;
    }

    return Object.keys(props).reduce((total, current) => {
        total += styles[props[current]] || '';
        return total;
    }, '');
};

const brandings = {
    alka: <ALKA height={'30px'} width={'190px'} fill={'#fff'} />,
    btdk: <BTDK height={'30px'} />,
    comeon: <COMEON height={'40px'} />,
    comeon18: <COMEON18 height={'40px'} width={'40px'} />,
    comeon_black: <COMEONBLACK height={'40px'} />,
    comeon_box: <COMEONBOX height={'40px'} />,
};

const BrandingWrapper = styled.div`
    z-index: 2;
    background: ${props => props.theme.brandingBackground};
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    padding: ${props => props.theme.brandingProps.padding.replace(/([1-9][0-9]+)/g, '$1px')};
    width: ${props => props.theme.brandingProps.width || 'auto'};
    ${props => props.css};
    div {
        margin: 0 15px;
    }
`;

const AdditionalContent = styled.div`
    position: absolute;
    left: 50 %;
    top: 50 %;
    transform: translate(-50 %, -50 %);
`;

const Branding = props => {
    const { children, visibility, additionalContent, theme } = props;
    if (visibility === 'hidden') return null;

    const [primary, secondary] = Array.isArray(children) ? children : [children, null];

    return (
        <BrandingWrapper css={getCss(props)} style={{ height: props.height }}>
            {!(visibility === 'secondary') && <div>{brandings[primary] || primary}</div>}
            {additionalContent && <AdditionalContent>{additionalContent}</AdditionalContent>}
            {!(visibility === 'primary') && secondary && <div>{brandings[secondary] || secondary}</div>}
        </BrandingWrapper>
    );
};

const defaultProps = TemplateConstants.BRANDING;

const options = {
    position: ['bottom', 'top'],
    order: ['ltr', 'rtl'],
    placement: ['relative', 'absolute'],
    alignment: ['left', 'right', 'center', 'edges'],
    visibility: ['hidden', 'primary', 'secondary', 'both'],
};

Branding.defaultProps = defaultProps;

Branding.propTypes = {
    position: PropTypes.oneOf(options['position']),
    order: PropTypes.oneOf(options['order']),
    placement: PropTypes.oneOf(options['placement']),
    alignment: PropTypes.oneOf(options['alignment']),
    children: PropTypes.array,
    visibility: PropTypes.oneOf(options['visibility']),
    height: PropTypes.string,
    additionalContent: PropTypes.node,
};

export default withTheme(Branding);
export { options, defaultProps as defaultOptions, brandings };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/Branding.js
 **/